import React, { useState, useEffect } from 'react';
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Footer from "./components/Footer";
import CreeperRunner from "./components/ui/CreeperRunner";
import { BrowserRouter } from "react-router-dom";
import { Analytics } from '@vercel/analytics/react';

function App() {
  const [reduceMotion, setReduceMotion] = useState(() => {
    return localStorage.getItem('reduceMotion') === 'true';
  });

  useEffect(() => {
    if (reduceMotion) {
      document.documentElement.classList.add('reduce-motion');
      localStorage.setItem('reduceMotion', 'true');
    } else {
      document.documentElement.classList.remove('reduce-motion');
      localStorage.setItem('reduceMotion', 'false');
    }
  }, [reduceMotion]);

  return (
    <BrowserRouter>
      <Analytics />
      <div className="App bg-[#121212] min-h-screen text-slate-200 antialiased relative selection:bg-green-700 selection:text-white">
        <Navbar reduceMotion={reduceMotion} setReduceMotion={setReduceMotion} />
        <Hero reduceMotion={reduceMotion} />
        <Experience />
        <Skills />
        <Projects />
        <Footer />
        <CreeperRunner reduceMotion={reduceMotion} />
      </div>
    </BrowserRouter>
  );
}

export default App;
